import { ErrorPage } from "@nested/rebrand";
import { createUniversalRoute } from "../../utils/createUniversalRoute";
import { blogRoutes } from "../RebrandBlogLayout/routes";

export const routes = [
  {
    path: "/rebrand-e2e-tests/:item?",
    name: "RebrandE2eTests",
  },
  {
    path: "/blog",
    name: "RebrandBlogLayout",
    routes: blogRoutes,
  },
  {
    path: "/for-sale/:postcodeSector/:roadName/:dealExternalId/enquiry",
    name: "PropertyEnquiry",
  },
  {
    path: "/for-sale/:postcodeSector/:roadName/:dealExternalId",
    name: "RebrandIndividualPropertyPage",
  },
  {
    path: "/wandsworth",
    name: "LocalLandingPage",
    props: { area: "wandsworth" },
  },
  {
    path: "/islington",
    name: "LocalLandingPage",
    props: { area: "islington" },
  },
  {
    path: "/greenwich",
    name: "LocalLandingPage",
    props: { area: "greenwich" },
  },
  {
    path: "/walthamstow",
    name: "LocalLandingPage",
    props: { area: "walthamstow" },
  },
  {
    path: "/battersea",
    name: "LocalLandingPage",
    props: { area: "battersea" },
  },
  {
    path: "/:item?",
    name: "RebrandPage",
  },
];

export const rebrandRoutes = routes.map((route) =>
  createUniversalRoute(route, ErrorPage),
);
